import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { articles, categories } from '@/mocks/articles';

const articleDetails: Record<string, {
  content: string;
  faq?: { question: string; answer: string }[];
}> = {
  'goal-record-overview': {
    content: `<p>郝海东在其长达18年的职业生涯中，共在顶级联赛中打入<strong>96粒进球</strong>，这一数字长期占据中国顶级联赛历史射手榜首位，成为中国足球史上最具标志性的数据之一。</p>
    <h3>进球分布概览</h3>
    <p>郝海东的96粒顶级联赛进球中，大部分是在效力大连实德（及前身大连万达）期间打入的。他在八一队时期就已经展现出惊人的进球天赋，转会大连后更是迎来了进球效率的巅峰。</p>
    <p>从进球方式来看，郝海东擅长多种得分手段：禁区内的抢点射门、单刀球的冷静处理、头球攻门以及禁区外的远射。他最为人称道的是在反击中的速度和射门精度，常常能在电光火石之间完成致命一击。</p>
    <h3>赛季进球统计</h3>
    <p>1996赛季，郝海东以13粒进球首次获得甲A联赛最佳射手称号。随后的1997和1998赛季，他连续两年蝉联这项荣誉，展现出惊人的稳定性。即便在职业生涯后期，他依然保持着较高的进球效率。</p>
    <h3>历史地位</h3>
    <p>郝海东的96球纪录在中国足坛具有里程碑意义。这不仅是数字上的成就，更代表了一个时代中国前锋的最高水准。在那个中国足球蓬勃发展的年代，郝海东用进球定义了什么是顶级前锋。</p>`,
    faq: [
      { question: '郝海东职业生涯一共打进了多少球？', answer: '郝海东在中国顶级联赛中共打入96粒进球，长期占据历史射手榜首位。此外他在国家队层面也有41粒进球入账。' },
      { question: '郝海东在哪几个赛季获得最佳射手？', answer: '郝海东在1996、1997和1998连续三个赛季获得甲A联赛最佳射手称号，展现出惊人的稳定性和进球能力。' },
    ],
  },
  'national-team-debut': {
    content: `<p>1992年，年仅22岁的郝海东首次披上中国国家队的战袍，从此开启了一段长达12年的国家队传奇征程。那一年，中国足球正处于新旧交替的关键时期，郝海东的崛起为中国队注入了新的活力。</p>
    <h3>首秀表现</h3>
    <p>郝海东的国家队首秀展现出了超越年龄的成熟和自信。他在前场的跑动、接应和射门都显示出与众不同的天赋。虽然首场比赛未能取得进球，但他的表现已经让所有人看到了一个未来巨星的雏形。</p>
    <h3>从新人到核心</h3>
    <p>在随后的几年里，郝海东逐渐从国家队的新人成长为进攻核心。他的速度、技术和门前嗅觉使他成为中国队最可靠的得分点。在他效力国家队的12年间，他始终是锋线上的第一选择。</p>
    <h3>历史意义</h3>
    <p>郝海东的国家队首秀不仅是他个人职业生涯的重要里程碑，也是中国足球一个时代的开始。从1992年到2004年，他见证了也参与了中国足球最辉煌的一段历程，包括历史性地闯入2002年世界杯决赛圈。</p>`,
    faq: [
      { question: '郝海东什么时候首次代表国家队出场？', answer: '郝海东于1992年首次代表中国国家队出场，当时他年仅22岁。' },
      { question: '郝海东在国家队效力了多少年？', answer: '郝海东的国家队生涯从1992年持续到2004年，共12年时间，出场107次，打入41球。' },
    ],
  },
  'dalian-golden-era': {
    content: `<p>1997年，郝海东转会加盟大连万达（后更名为大连实德），这个决定改变了他职业生涯的轨迹，也开启了中国足球俱乐部层面最辉煌的一段岁月。</p>
    <h3>加盟大连</h3>
    <p>加盟大连万达时，郝海东已经是中国足坛公认的顶级前锋。大连万达是当时中国足坛实力最强的俱乐部之一，两者的结合堪称完美。郝海东的加盟让大连万达的进攻实力达到了一个新的高度。</p>
    <h3>冠军岁月</h3>
    <p>在大连效力期间，郝海东帮助球队获得了5次甲A联赛冠军和2次足协杯冠军。他个人也三次获得中国足球先生称号，成为这个时期的标志性人物。大连实德的黄金时代与郝海东的巅峰期高度重合。</p>
    <h3>战术核心</h3>
    <p>在大连实德的战术体系中，郝海东是不可替代的核心。球队的进攻围绕他展开，他的跑位、做球和终结能力让整个进攻体系流畅运转。他与队友的默契配合，特别是与中场球员的连线，成为大连实德攻城拔寨的利器。</p>`,
    faq: [
      { question: '郝海东在大连实德获得了多少冠军？', answer: '郝海东在大连实德（含前身大连万达）期间共获得5次甲A联赛冠军和2次足协杯冠军。' },
    ],
  },
  'world-cup-qualifier': {
    content: `<p>2002年韩日世界杯亚洲区预选赛是中国足球历史上最重要的篇章之一，而郝海东在这一过程中的出色发挥，为中国队历史性首次闯入世界杯决赛圈立下了汗马功劳。</p>
    <h3>预选赛征程</h3>
    <p>在通往2002年世界杯的道路上，郝海东展现出了顶级前锋的全部素质。他在关键比赛中的进球和助攻，多次为中国队打开胜利之门。他的经验、冷静和把握机会的能力，在高压的预选赛环境中显得尤为珍贵。</p>
    <h3>世界杯正赛</h3>
    <p>虽然在世界杯正赛中中国队未能取得进球和胜利，但对于郝海东和中国足球来说，站上世界杯的舞台本身就是一种巨大的突破和荣耀。郝海东在世界杯上的每一次触球，都承载着中国球迷的期望和梦想。</p>
    <h3>时代意义</h3>
    <p>2002年世界杯不仅改变了郝海东的职业生涯地位，也在中国足球史上留下了不可磨灭的印记。郝海东作为这一历史性突破的核心参与者，他的贡献将永远被中国球迷铭记。</p>`,
  },
  'controversy-retirement': {
    content: `<p>郝海东的职业生涯并非一帆风顺。作为一个性格鲜明、敢说敢做的球员，他的某些言行和决定在公众和媒体中引发了广泛讨论和争议。</p>
    <h3>与教练的矛盾</h3>
    <p>在郝海东的职业生涯中，他与部分教练的关系曾成为媒体关注的焦点。作为一名个性强烈、对足球有自己理解的球员，他与教练在战术理念和用人方面的分歧，曾多次被媒体报道和放大。</p>
    <h3>公众言论</h3>
    <p>退役后，郝海东在社交媒体和公开场合的言论也多次引发争议。他的直言不讳和独特的观点，让他在退役后依然处于舆论的中心。这些争议既是郝海东个人性格的体现，也反映了中国足球环境中一些深层次的问题。</p>
    <h3>客观评价</h3>
    <p>无论如何评价这些争议，不可否认的是，郝海东在中国足球史上的地位是确定无疑的。争议与他辉煌的成就共同构成了一个真实、立体的郝海东形象。</p>`,
  },
  'hao-haidong-biography': {
    content: `<p>郝海东，1970年5月9日出生于山东省青岛市，中国足球史上最具传奇色彩的前锋球员。从一个青岛普通家庭的少年，到成为中国足球标志性人物，郝海东的人生轨迹充满了传奇色彩。</p>
    <h3>早年经历</h3>
    <p>郝海东从小就展现出过人的足球天赋。在青岛的街头和学校球场上，他的速度和技术在同龄人中鹤立鸡群。1986年，16岁的郝海东入选八一青年队，正式开始了他的职业足球生涯。</p>
    <h3>职业生涯</h3>
    <p>从八一队到大连万达/实德，从甲A联赛到世界杯舞台，郝海东的职业生涯跨越了18年。在这18年间，他用96粒联赛进球和41粒国家队进球，书写了中国足球史上最辉煌的个人纪录之一。</p>
    <h3>退役之后</h3>
    <p>2007年退役后，郝海东并未远离足球。他从事过教练工作、足球评论员以及多种足球相关的事业。他的退役生活和他球员时期一样，充满了话题和关注。</p>`,
    faq: [
      { question: '郝海东是哪里人？', answer: '郝海东1970年5月9日出生于山东省青岛市。' },
      { question: '郝海东的身高是多少？', answer: '郝海东身高180厘米，体重约73公斤，是一名典型的速度型前锋。' },
      { question: '郝海东什么时候退役的？', answer: '郝海东于2007年正式宣布退役，结束了他长达18年的职业足球生涯。' },
    ],
  },
  'goal-per-match-analysis': {
    content: `<p>郝海东之所以被称为传奇，不仅因为他的进球总数惊人，更因为他在关键比赛中的稳定输出。通过数据分析，我们可以更清晰地看到这位前锋的进攻效率。</p>
    <h3>进球效率分析</h3>
    <p>在郝海东的巅峰赛季，他的场均进球率接近0.7球，这在当时的中国足坛是一个极为罕见的数据。即使在整个职业生涯的平均数据中，他的进球效率也远超同时代的绝大多数前锋。</p>
    <h3>关键比赛表现</h3>
    <p>郝海东在关键比赛中的表现尤其值得称道。在争冠关键战、国家队重要比赛和亚洲赛事中，他多次挺身而出，用进球为球队带来胜利。这种在压力下的得分能力，是衡量一个顶级前锋的重要标准。</p>`,
  },
  'asian-cup-2004': {
    content: `<p>2004年亚洲杯是中国足球史上最令人难忘的赛事之一，而郝海东在决赛中带伤作战的画面，成为中国足球最动人的瞬间之一。</p>
    <h3>决赛之夜</h3>
    <p>2004年亚洲杯决赛在中国北京举行，中国队对阵日本队。比赛中，郝海东在一次拼抢中头部受伤，鲜血染红了他的球衣。然而在经过简单的包扎后，他毅然选择继续比赛。</p>
    <h3>精神的象征</h3>
    <p>郝海东带伤坚持比赛的精神感动了无数中国球迷。虽然他头上的绷带和血迹令人心疼，但他不屈的斗志成为了中国足球精神的象征。尽管中国队最终以1-3遗憾落败，但郝海东的表现赢得了所有人的尊重。</p>
    <h3>深远影响</h3>
    <p>这场决赛虽然未能夺冠，但郝海东的表现激励了一代中国球员和球迷。他用实际行动诠释了什么是职业精神和对国家队的忠诚。</p>`,
  },
  'dalian-tactics': {
    content: `<p>在大连实德的战术体系中，郝海东扮演着不可替代的角色。他不仅是进球机器，更是整个进攻体系运转的核心枢纽。</p>
    <h3>战术定位</h3>
    <p>郝海东在前锋位置上的战术价值远超单纯的进球。他的跑位能力为队友创造了大量空间，他的背身拿球和做球能力让中场的传球有了稳定的接应点，他的速度则让对手的防线始终处于紧张状态。</p>
    <h3>与队友的配合</h3>
    <p>在大连实德，郝海东与多名优秀中场和边路球员形成了默契的配合。无论是一脚传递的快速反击，还是阵地战中的耐心组织，郝海东都能完美地融入球队的战术需要。</p>`,
  },
  'controversy-media': {
    content: `<p>郝海东与媒体的关系一直是中国足坛一个有趣的话题。作为一名个性鲜明的球员，他在媒体上的形象经历了多次变迁。</p>
    <h3>早期的媒体形象</h3>
    <p>在职业生涯早期，郝海东在媒体中的形象主要是"天才少年"和"进球机器"。媒体热衷于报道他在场上的精彩表现和进球纪录，他成为了中国足球的希望之星。</p>
    <h3>舆论风波</h3>
    <p>随着职业生涯的深入，郝海东的一些争议言论和行为开始引发媒体和公众的广泛讨论。他直言不讳的性格让他在媒体上占据了大量版面，但也给他带来了不少麻烦。</p>
    <h3>多维度的评价</h3>
    <p>如今回看郝海东与媒体的关系，可以看到一个复杂而有趣的图景。他既是中国足球媒体最关注的明星之一，也是最具争议的公众人物之一。这种复杂性恰恰构成了真实郝海东的一部分。</p>`,
  },
  'player-profile-detail': {
    content: `<p>全面了解郝海东的身体素质、技术特点和场上位置，有助于理解他为什么能成为中国足球史上最伟大的前锋之一。</p>
    <h3>基本信息</h3>
    <p>郝海东，身高180厘米，体重约73公斤。这个体型在足球运动员中属于中等偏瘦的类型，但出色的爆发力和速度让他可以轻松摆脱防守球员的纠缠。</p>
    <h3>技术特点</h3>
    <p>郝海东最大的技术优势是他的速度和射门精度。他的启动速度极快，一旦获得空间几乎不可阻挡。他的射门技术全面，无论是左脚还是右脚都能完成高质量的射门。此外，他的头球能力也不容小觑，经常能在定位球进攻中制造威胁。</p>
    <h3>场上位置</h3>
    <p>郝海东是一名纯粹的9号前锋，主要活动在对方禁区内和禁区前沿。他善于利用防线身后的空间，是最典型的"机会主义者"型前锋。同时，他的跑位智慧让他能够不断找到防守漏洞。</p>`,
  },
  'top-10-goals': {
    content: `<p>在郝海东的96粒顶级联赛进球中，有许多进球因其精彩程度而成为经典。本文精选其中十粒最令人叹为观止的进球，带你回顾那些让人热血沸腾的瞬间。</p>
    <h3>长途奔袭</h3>
    <p>在郝海东的十佳进球中，长途奔袭是出现频率最高的类型。他从中场附近启动，凭借惊人的速度连续过掉多名防守球员，最终在禁区内完成冷静射门。这种进球方式完美展现了他的速度和技术结合的能力。</p>
    <h3>凌空抽射</h3>
    <p>郝海东也多次上演过精彩的凌空抽射。无论是接队友传中后的直接凌空射门，还是在混战中的即兴发挥，这些进球都体现了他出色的身体协调性和射门感觉。</p>
    <h3>关键绝杀</h3>
    <p>在十佳进球中，一些关键比赛中的绝杀进球因其重要性和戏剧性而入选。这些进球不仅精彩，更承载了球迷的情感记忆。</p>`,
  },
};

export default function Article() {
  const { slug } = useParams<{ slug: string }>();

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="pt-24 min-h-[60vh] flex flex-col items-center justify-center px-4">
          <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">
            文章未找到
          </h1>
          <Link
            to="/"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const detail = articleDetails[article.slug];
  const category = categories.find((c) => c.slug === article.category);
  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.slug !== article.slug)
    .slice(0, 3);

  const getCategoryName = (catSlug: string) => {
    const cat = categories.find((c) => c.slug === catSlug);
    return cat ? cat.name : catSlug;
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <Breadcrumb />
      </div>
      <main>
        <article className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <Link
              to={`/category/${article.category}`}
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 hover:bg-accent-200 transition-colors whitespace-nowrap"
            >
              {category?.name || article.category}
            </Link>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>

            <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500 mb-8 pb-6 border-b border-background-200/70">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                {article.date}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                {article.readTime}
              </span>
            </div>

            <div className="relative w-full aspect-[16/9] rounded-xl overflow-hidden mb-10">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
                title={`${article.title} - 郝海东官方介绍站`}
              />
            </div>

            {detail?.content ? (
              <div
                className="prose-custom text-foreground-800 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: genArticleHTML(detail.content) }}
              />
            ) : (
              <div className="text-foreground-700 leading-relaxed space-y-4">
                <p>{article.excerpt}</p>
                <p>本篇文章正在持续更新中，敬请期待更多详实内容。</p>
              </div>
            )}

            {detail?.faq && detail.faq.length > 0 && (
              <section className="mt-12 pt-8 border-t border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">
                  常见问题
                </h2>
                <div className="flex flex-col gap-4">
                  {detail.faq.map((item, idx) => (
                    <details
                      key={idx}
                      className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
                    >
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors">
                        <span className="font-medium text-foreground-900 text-sm pr-4">
                          {item.question}
                        </span>
                        <span className="text-foreground-400 group-open:rotate-180 transition-transform duration-200 shrink-0">
                          <i className="ri-arrow-down-s-line"></i>
                        </span>
                      </summary>
                      <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                        {item.answer}
                      </div>
                    </details>
                  ))}
                </div>
              </section>
            )}
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8">
                相关文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((ra) => (
                  <ArticleCard
                    key={ra.id}
                    id={ra.id}
                    slug={ra.slug}
                    title={ra.title}
                    excerpt={ra.excerpt}
                    image={ra.image}
                    date={ra.date}
                    readTime={ra.readTime}
                    category={ra.category}
                    categoryName={getCategoryName(ra.category)}
                  />
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}

function genArticleHTML(content: string): string {
  return content
    .replace(/<h3>/g, '<h3 class="font-heading text-lg font-semibold text-foreground-900 mt-8 mb-3">')
    .replace(/<p>/g, '<p class="text-foreground-700 leading-relaxed mb-4">')
    .replace(/<strong>/g, '<strong class="text-foreground-900 font-semibold">');
}